// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    location: "qa2",
    configURL: "assets/config/gmsconfig.json",
    translationURL: "assets/locales/en_US/translations.json",
    urls: {
        api: {
            apiUsnjBaseUrl: "http://angular-nj-gms.ivycomptech.co.in/api/",
            login: "validate_login",
            logout: "logout",
            changewordpUrl: "insert_new_password"
        }
    },
    gmsConfig: {},
    translations: {},
    language: "",
    dynaconStaticData: {
        "dynacon_dataReports": {
        },
        "dynacon_gameManagement": {
            "patternBallTypes": [
                {
                    "id": 30,
                    "name": "30 Ball Game",
                    "rows": 3,
                    "cols": 3
                },
                {
                    "id": 75,
                    "name": "75 Ball Game",
                    "rows": 5,
                    "cols": 5
                },
                {
                    "id": 80,
                    "name": "80 Ball Game",
                    "rows": 4,
                    "cols": 4
                },
                {
                    "id": 90,
                    "name": "90 Ball Game",
                    "rows": 3,
                    "cols": 9
                },
                {
                    "id": 50,
                    "name": "50 Ball Game",
                    "rows": 2,
                    "cols": 5
                },
                {
                    "id": 36,
                    "name": "36 Ball Game",
                    "rows": 4,
                    "cols": 4
                },
                {
                    "id": 52,
                    "name": "52 Ball Game",
                    "rows": 1,
                    "cols": 5
                }
            ],
            "categoryData": [
                {
                    "id": "new",
                    "value": "new"
                },
                {
                    "id": "special",
                    "value": "special"
                },
                {
                    "id": "featured",
                    "value": "featured"
                },
                {
                    "id": "newbie",
                    "value": "newbie"
                },
                {
                    "id": "private",
                    "value": "private"
                },
                {
                    "id": "prelogin-display",
                    "value": "prelogin-display"
                },
                {
                    "id": "postlogin-display",
                    "value": "postlogin-display"
                },
                {
                    "id": "beta-testing",
                    "value": "beta-testing"
                },
                {
                    "id": "freegame",
                    "value": "freegame"
                }
            ],
            "tournamentsPtrn": [
                "First Line,Second Line,Third Line,Full House,Roll on 1,Roll on 2,Roll on 3,Roll on 4,Roll on 5",
                "Any Line,Any Two Lines,Full House,Roll on 1,Roll on 2,Roll on 3,Roll on 4,Roll on 5"
            ],
            "tournamentFeatures": [
                "ntogo",
                "everyone_wins",
                "losing_tickets",
                "double_numbers",
                "win_in_x_call",
                "special_number"
            ],
            "killEnabledUserList": [
                "jag",
                "dhanaqa2",
                "phansen",
                "mohanqa2",
                "jahnaviqa2",
                "sirisha_superadmin",
                "venkyqa2",
                "arama",
                "test"
            ],
            "gameRoomVariant": [
                {
                    "key": "battleroyale",
                    "value": "Battle Royale"
                }
            ],
            "roomVariant": [
                {
                    "key": "bingo",
                    "value": "Bingo"
                },
                {
                    "key": "matchbingo",
                    "value": "Match bingo"
                },
                {
                    "key": "bingobeats",
                    "value": "Bingo beats"
                },
                {
                    "key": "battleroyale",
                    "value": "Battle royale"
                },
                {
                    "key": "slingobingo",
                    "value": "Slingo bingo"
                },
                {
                    "key": "fishinfrenzy",
                    "value": "Fishinfrenzy"
                }
            ],
            "socketversions": [
                {
                    "id": 1,
                    "value": "Version 1"
                },
                {
                    "id": 2,
                    "value": "Version 2"
                }
            ],
            "amountType": [
                {
                    "id": 1,
                    "name": "Bingo Cash"
                },
                {
                    "id": 2,
                    "name": "Real Money"
                },
                {
                    "id": 3,
                    "name": "Bonus Money"
                },
                {
                    "id": 4,
                    "name": "Real and Bonus"
                }
            ],
            "paginationFeatures": [
                "whack_a_bingo_chat"
            ],
            "ball_colours": [
                {
                    "color": "#7100cc",
                    "val": [
                        1,
                        15
                    ]
                },
                {
                    "color": "#00aeff",
                    "val": [
                        16,
                        30
                    ]
                },
                {
                    "color": "#00e93e",
                    "val": [
                        31,
                        45
                    ]
                },
                {
                    "color": "#ffff61",
                    "val": [
                        46,
                        60
                    ]
                },
                {
                    "color": "#ffc63b",
                    "val": [
                        61,
                        75
                    ]
                },
                {
                    "color": "#fb002c",
                    "val": [
                        76,
                        90
                    ]
                }
            ],
            "reward_features": [
                {
                    "feature_type": "whack_a_bingo"
                },
                {
                    "feature_type": "prize_wheel"
                }
            ],
            "brb2Data": {
                "unique_balls": {
                    "min": 2,
                    "max": 99
                },
                "no_of_players": {
                    "min": 1,
                    "max": 99
                },
                "max_insurance_time": {
                    "min": 1,
                    "max": 999
                }
            },
            "bingo_packages_repeat_limit": {
                "default": 120,
                "daily": 150,
                "weekly": 180,
                "monthly": 200
            },
            "show_dynamic_calculator": true,
            "max_allowed_coins": 999999,
            "removeFeatures": {
                "isLinkedGame": false,
                "game": {
                    "isSatelliteBingo": false
                },
                "features": [
                    "team_bingo",
                    "bingo_boom",
                    "side_bets",
                    "fomo_bingo"
                ],
                "pjp": {
                    "isTimed": false
                }
            }
        },
        "dynacon_gmsCommonSettings": {
            "connectAws": true,
            "apiUrl": "https://ol9qa2-angular-gms.ivycomptech.co.in/api/",
            "awsApiUrl": "https://bingo-gms-api.entain-bingo-mumbai-dev.aws.local/",
            "rowsPerPage": [
                {
                    "id": 20,
                    "name": "20 rows per page"
                },
                {
                    "id": 40,
                    "name": "40 rows per page"
                },
                {
                    "id": 60,
                    "name": "60 rows per page"
                },
                {
                    "id": 80,
                    "name": "80 rows per page"
                },
                {
                    "id": 100,
                    "name": "100 rows per page"
                },
                {
                    "id": 150,
                    "name": "150 rows per page"
                },
                {
                    "id": 200,
                    "name": "200 rows per page"
                },
                {
                    "id": 250,
                    "name": "250 rows per page"
                },
                {
                    "id": 300,
                    "name": "300 rows per page"
                }
            ],
            "ballTypes": [
                {
                    "id": 30,
                    "name": "30 Ball Game"
                },
                {
                    "id": 75,
                    "name": "75 Ball Game"
                },
                {
                    "id": 80,
                    "name": "80 Ball Game"
                },
                {
                    "id": 90,
                    "name": "90 Ball Game"
                },
                {
                    "id": 50,
                    "name": "50 Ball Game"
                },
                {
                    "id": 36,
                    "name": "36 Ball Game"
                },
                {
                    "id": 52,
                    "name": "52 Ball Game"
                }
            ]
        },
        "dynacon_administration": {
            "gameFeatureTypes": [
                {
                    "name": "Internal",
                    "type": "internal"
                },
                {
                    "name": "External",
                    "type": "external"
                },
                {
                    "name": "Chat",
                    "type": "chat"
                }
            ]
        },
        "dynacon_chatManagement": {
            "chatTypes": [
                {
                    "value": "group",
                    "viewValue": "Group"
                },
                {
                    "value": "private",
                    "viewValue": "Private"
                }
            ]
        },
        "dynacon_customerService": {
            "customer-service": [
                0,
                1,
                2,
                3
            ],
            "player_search": {
                "players_management": {
                    "is_alias_editable": true,
                    "is_chat_editable": true,
                    "is_property_editable": true,
                    "is_presenter_editable": true
                }
            }
        }
    }
};


/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
